import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useGroupUserInvitationsState() {
  return useAppState();
}

export function useGroupUserInvitationsActions() {
  const dispatch = useAppDispatch();

  function initializeState(groupId) {
    dispatch((appState) => ({
      ...appState,
      groupId: groupId || '',
      newOpenUserInvitation: {
        firstName: '',
        lastName: '',
        email: '',
        groupId: groupId || '',
      },
      openUserInvitations: [],
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function updateFirstName(firstName) {
    dispatch((appState) => ({
      ...appState,
      newOpenUserInvitation: {
        ...appState.newOpenUserInvitation,
        firstName: firstName,
      }
    }));
  }

  function updateLastName(lastName) {
    dispatch((appState) => ({
      ...appState,
      newOpenUserInvitation: {
        ...appState.newOpenUserInvitation,
        lastName: lastName,
      }
    }));
  }

  function updateEmail(email) {
    dispatch((appState) => ({
      ...appState,
      newOpenUserInvitation: {
        ...appState.newOpenUserInvitation,
        email: email,
      }
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    updateFirstName,
    updateLastName,
    updateEmail,
    clearFeedback,
  };
}
